export default [
    'assets/images/emoticons/geamuseerd@2x.png',
    'assets/images/emoticons/gelukkig@2x.png',
    'assets/images/emoticons/geliefd@2x.png',
    'assets/images/emoticons/gezellig@2x.png',
    'assets/images/emoticons/kalm@2x.png',
    'assets/images/emoticons/levendig@2x.png',
    'assets/images/emoticons/nieuwsgierig@2x.png',
    'assets/images/emoticons/opgelucht@2x.png',
    'assets/images/emoticons/ontroerd@2x.png',
    'assets/images/emoticons/ontspannen@2x.png',
    'assets/images/emoticons/opgewekt@2x.png',
    'assets/images/emoticons/verliefd@2x.png',
    'assets/images/emoticons/tevreden@2x.png',
    'assets/images/emoticons/trots@2x.png',
    'assets/images/emoticons/verbaasd@2x.png',
    'assets/images/emoticons/vurig@2x.png',
    'assets/images/emoticons/zalig@2x.png',
    'assets/images/emoticons/bang@2x.png',
    'assets/images/emoticons/droevig@2x.png',
    'assets/images/emoticons/beschaamd@2x.png',
    'assets/images/emoticons/futloos@2x.png',
    'assets/images/emoticons/gefrustreerd@2x.png',
    'assets/images/emoticons/gekwetst@2x.png',
    'assets/images/emoticons/geschrokken@2x.png',
    'assets/images/emoticons/gespannen@2x.png',
    'assets/images/emoticons/kwaad@2x.png',
    'assets/images/emoticons/moe@2x.png',
    'assets/images/emoticons/moedeloos@2x.png',
    'assets/images/emoticons/nerveus@2x.png',
    'assets/images/emoticons/ongelukkig@2x.png',
    'assets/images/emoticons/overstuur@2x.png',
    'assets/images/emoticons/schuldig@2x.png',
    'assets/images/emoticons/verdrietig@2x.png',
    'assets/images/emoticons/verward@2x.png',
    'assets/images/emoticons/wanhopig@2x.png',
    'assets/images/emoticons/energiek@2x.png',
    'assets/images/avatars/avatar_1@2x.png',
    'assets/images/avatars/avatar_2@2x.png',
    'assets/images/avatars/avatar_3@2x.png',
    'assets/images/avatars/avatar_4@2x.png',
    'assets/images/avatars/avatar_5@2x.png',
    'assets/images/avatars/avatar_6@2x.png',
    'assets/images/avatars/avatar_7@2x.png',
    'assets/images/avatars/avatar_8@2x.png',
    'assets/images/avatars/avatar_9@2x.png',
    'assets/images/avatars/avatar_10@2x.png',
    'assets/images/avatars/avatar_11@2x.png',
    'assets/images/avatars/avatar_12@2x.png',
    'assets/images/avatars/avatar_13@2x.png',
    'assets/images/avatars/avatar_14@2x.png',
    'assets/images/avatars/avatar_15@2x.png',
    'assets/images/avatars/avatar_16@2x.png',
];



// WEBPACK FOOTER //
// ./src/preloadImages.js